import React, { useContext, useEffect } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { editPatient, getPatient } from '../../redux/Patient/PatientAction';
import PatientForm from './PatientForm';
import { useParams } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useWidth';
import WithPatientFileHeader from '../PatientFileHeader/WithPatientFileHeader';
import LanguageContext from '../../contexts/languageContext';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Patient/PatientType';

const styles = makeStyles({
    container: {
        position: 'relative'
    }
});
const EditPatient = () => {
    const classes = styles();
    const isMobile = useCheckMobileScreen();
    const dispatch = useDispatch();
    const params = useParams();
    const patient = useSelector((state) => state.patient.patient.profile);
    const loadingSelector = createLoadingSelector(type.GET_PATIENT.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const { lang } = useContext(LanguageContext);

    // const deleteDescription = `توضیحاتی راجع به اینکه از حذف این بیمار ممکنه بعدا پشیمان شوید و...`;
    useEffect(() => {
        if (isMobile) {
            dispatch(getPatient(params?.id));
        }
        // because Navbar is on each page, we have to reguest to get the patient's info
    }, []);
    useEffect(() => {
        if (!patient || +patient.id !== +params?.id) {
            dispatch(getPatient(params?.id));
        }
    }, [params?.id]);
    // async function handleDeletePatient() {

    //     const response = await dispatch(deletePatient(params?.id));
    //     if (response?.status === 200) {
    //         history.replace(`/${params?.section}`);
    //     }
    // }
    const handleEditPatient = async (patient) => {
        const response = await dispatch(editPatient(params?.id, patient));
        return response;
    };
    // const closeModal = () => {
    //     history.replace('/patients');
    // };

    return (
        <>
            <div className={classes.container}>
                {isLoading ? (
                    <div className="loadingContainer">
                        <CircularProgress />
                    </div>
                ) : (
                    <PatientForm
                        formType="edit"
                        patient={patient}
                        submitPatient={handleEditPatient}
                        lang={lang}
                        // handleCancel={closeModal}
                    />
                )}
            </div>
            {/* <div className={classes.separator}></div>
                <div className={classes.deleteSection}>
                    <p>{this.deleteDescription}</p>
                    <div className={classes.submitBtnContainer}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => this.handleDeletePatient()}
                        >
                            حذف بیمار
                        </Button>
                    </div>
                </div> */}
        </>
    );
};
EditPatient.propTypes = {
    classes: PropTypes.object,
    getPatient: PropTypes.any,
    match: PropTypes.any,
    deletePatient: PropTypes.any,
    patient: PropTypes.object,
    editPatient: PropTypes.any,
    history: PropTypes.any
};

export default WithPatientFileHeader(EditPatient, ['sidebar', 'patientFile'], false, 'white');
